import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

// Styled Components
const HeaderSection = styled.header`
  .container-fluid {
    padding: 0 15px;
  }
`;

const Logo = styled.div`
  img {
    max-height: 56px;
  }
`;

const NavMenu = styled.nav`
  @media (max-width: 768px) {
    display: none;

    &.mobile-menu-open {
      display: block;
    }
  }
`;

const NavMenuButton = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
    cursor: pointer;
    font-size: 20px;
    color: #009603;
    margin-top: 1rem;
    margin-right: -1rem;
  }
`;

const TopSearch = styled.div`
  background: white;
  display: flex;
  a {
    color: #009603;
    font-size: 20px;
    margin-left: 1rem;
    &:first-child {
      margin-left: 0;
    }
    @media (max-width: 768px) {
      font-size: 20px;
      margin-left: 0.5rem;
    }
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;

  @media (max-width: 768px) {
    display: block; /* Change from flex to block on mobile */
    text-align: left; /* Adjust text alignment if needed */
  }
`;

const LogoContainer = styled.div`
  margin-left: -10rem;

  @media (max-width: 768px) {
    margin-left: 0; /* Remove margin on mobile */
  }
`;

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const [isMobile, setIsMobile] = useState(false);

  // Update the state based on the window width
  const checkMobile = () => {
    if (window.innerWidth <= 768) {
      // 768px is the typical breakpoint for mobile
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    // Check on initial load
    checkMobile();

    // Set up a resize event listener
    window.addEventListener("resize", checkMobile);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  return (
    <HeaderSection className="header-section">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <HeaderContainer>
              <Logo className="logo">
                <Link to="/">
                  <img src="img/logored.png" alt="Logo" />
                </Link>
              </Logo>
              <LogoContainer>
                <NavMenu
                  className={`nav-menu ${
                    mobileMenuOpen ? "mobile-menu-open" : "mobile-menu"
                  }`}
                >
                  <ul style={{ textAlign: "-webkit-center" }}>
                    <li>
                      <Link to="/" onClick={closeMobileMenu}>
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/about" onClick={closeMobileMenu}>
                        About
                      </Link>
                    </li>
                    <li>
                      <Link to="/clicks" onClick={closeMobileMenu}>
                        Clicks
                      </Link>
                    </li>
                    <li>
                      <Link to="/blogs" onClick={closeMobileMenu}>
                        Blogs
                      </Link>
                    </li>
                    <li>
                      <Link to="/policy" onClick={closeMobileMenu}>
                        Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact" onClick={closeMobileMenu}>
                        Contact
                      </Link>
                    </li>
                  </ul>
                </NavMenu>
              </LogoContainer>
              <TopSearch
                style={{ display: "flex", justifyContent: "end" }}
                className="top-search search-switch"
              >
                <NavMenuButton
                  className="mobile-menu-button"
                  onClick={toggleMobileMenu}
                >
                  <i className="fa fa-bars"></i>
                </NavMenuButton>
                {isMobile === false ? (
                  <>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.facebook.com/share/1AtqdG3v43/?mibextid=LQQJ4d"
                    >
                      <i
                        className="fa fa-facebook"
                        style={{ color: "black" }}
                      ></i>
                    </a>
                    <a
                      href="https://www.youtube.com/@nageshamurthy4466"
                      target="_blank"
                    >
                      <i
                        className="fa fa-youtube-play"
                        style={{ color: "black" }}
                      ></i>
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.instagram.com/nageshmurthyclicks/profilecard/?igsh=MXUwdTBzMnJsNmUwbg=="
                    >
                      <i
                        className="fa fa-instagram"
                        style={{ color: "black" }}
                      ></i>
                    </a>
                  </>
                ) : (
                  ""
                )}
              </TopSearch>
            </HeaderContainer>
          </div>
        </div>
      </div>
    </HeaderSection>
  );
};

export default Header;
